module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1920x2-098a064b547c003f66274888076823b0.webp";